"use client";

import { FeatureHighlight } from "@/components/shared/public";
import { useTranslations } from "next-intl";
import {
  corporateIdent,
  largeScaleProj,
  ownIdea,
  whatCustom,
} from "../../../../public/images/individuel-floor-plan";

const SubInfo = () => {
  const t = useTranslations("individualFp.subInfo");

  return (
    <>
      <div className="gs--page-column py-16">
        <FeatureHighlight
          src={ownIdea}
          alt={"Icon eigene Ideen umsetzen"}
          title={t("feature.title")}
          text={t("feature.text")}
        />
      </div>

      <div className="bg-secondary">
        <div className="gs--page-column py-16">
          <FeatureHighlight
            src={corporateIdent}
            alt={"Icon Corporate Identity Grundrisse"}
            title={t("feature2.title")}
            text={t("feature2.text")}
          />
        </div>
      </div>

      <div className="gs--page-column py-16">
        <FeatureHighlight
          src={largeScaleProj}
          alt={"Icon Grossprojekte Grundrisse"}
          title={t("feature3.title")}
          text={t("feature3.text")}
        />
      </div>

      <div className="bg-secondary">
        <div className="gs--page-column py-16">
          <FeatureHighlight
            src={whatCustom}
            alt={"Individueller Grundriss Beispiel"}
            title={t("feature4.title")}
            text={t("feature4.text")}
          />
        </div>
      </div>
    </>
  );
};

export default SubInfo;
